import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get as getCookie } from 'js-cookie';
import styled, { css } from 'styled-components';
import { deleteItem } from 'ducks/cart';
import { Button } from 'components/shared';
import guestCartCookieName from 'helpers/guestCartCookieName';

const Wrapper = styled.div`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 84%;
  background-color: rgba(255, 255, 255, 0.7);
  justify-content: space-around;
  align-items: center;
  ${props =>
    css`
      display: ${props.isVisible ? 'flex' : 'none'};
    `};
`;

class DeleteCartItem extends React.Component {
  static propTypes = {
    cartItem: PropTypes.shape({
      id: PropTypes.integer,
    }).isRequired,
    deleteCartItem: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.onDeleteCartItem = this.onDeleteCartItem.bind(this);
  }

  async onDeleteCartItem() {
    const cartId = getCookie(guestCartCookieName);
    await this.props.deleteCartItem(cartId, this.props.cartItem.id);
    this.props.onClick();
  }

  render() {
    return (
      <Wrapper isVisible={this.props.isVisible}>
        <Button block blue small onClick={this.onDeleteCartItem}>
          Delete
        </Button>
        <Button block grey small onClick={this.props.onClick}>
          Cancel
        </Button>
      </Wrapper>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  deleteCartItem: deleteItem,
};
export default connect(mapStateToProps, mapDispatchToProps)(DeleteCartItem);



// WEBPACK FOOTER //
// ./src/components/shared/DeleteCartItem/DeleteCartItem.jsx